import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren } from 'react';
import { ContentContainer } from '@module/mdrt-org/shared/components/content-container/content-container';
import { HeroBackgroundGraphics } from '../svgs/hero-background-graphics';
import styles from './hero-section-content-wrapper.module.scss';
export const HeroSectionContentWrapper = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles["hero-section-content-wrapper__background"]} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={styles.content}>{children}{t1}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HeroBackgroundGraphics className={styles["background-graphics"]} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className={styles["hero-section-content-wrapper"]} data-testid="hero-section"><ContentContainer>{t2}{t3}</ContentContainer></div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};